import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";
import { UsersService } from "../../services/users/users.service";
import { Router, RouterOutlet, RouterModule } from "@angular/router"; 

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatSidenavModule,
    RouterModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatListModule,
    MatTooltipModule
] 
})
export class DefaultComponent {
  @ViewChild(RouterOutlet) outlet: RouterOutlet | undefined;
  @ViewChild('sidenav') sidenav: MatSidenav | undefined;
  public isExpanded: boolean;

  constructor(private authService: UsersService,
              private router: Router) {
    this.isExpanded = true;
  }

  toggleSidebar() {
    this.isExpanded = !this.isExpanded;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/']).then();
  }

  openProfile() {
    this.router.navigate(['/monitors/profile']);
  }

  openSettings() {
    this.router.navigate(['/monitors/config']);
    // this.router.navigate(['/monitors/configuracion']);
  }
}
